<template>
  <section>
    <div class="role">
      <div class="roleRight">
        <div class="roleRight_Top">
          <el-input
              v-if="searchShow"
              clearable
              v-model="search.searchKey"
              clas="input_search"
              placeholder="搜索关键字"
              @keyup.enter.native="SearchDictionaryList"
          ></el-input>
          <el-select v-if="searchShow" v-model="search.status" clearable placeholder="请选择">
            <el-option
                v-for="item in COMMON_STATUS"
                :key="item.key"
                :label="item.name"
                :value="item.key"
            ></el-option>
          </el-select>
          <el-button v-if="searchShow" size="medium" type="primary" @click="SearchDictionaryList"
          >查询
          </el-button
          >
          <el-button
              v-if="addShow"
              size="medium"
              type="primary"
              @click="handleClick('addNext')"
          >新增
          </el-button
          >
        </div>
        <div class="roleRight_Container public-table-data">
          <el-table
              v-loading="loading"
              :data="tableData"
              size="medium"
              border
              style="width: 100%"
          >
            <el-table-column fixed label="序号" type="index" width="100">
              <template slot-scope="scope">
                <span>{{ scope.$index + 1 }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="券名称" min-width="150">
            </el-table-column>
            <el-table-column prop="eventName" label="事件名称" min-width="100">
            </el-table-column>
            <el-table-column prop="price" label="金额" min-width="50">
            </el-table-column>
            <el-table-column prop="couponCount" label="数量" min-width="50">
            </el-table-column>
            <el-table-column prop="remarks" label="类型" min-width="150">
              <template slot-scope="scope">
                <div v-if="scope.row.couponType==1">现金券</div>
                <div v-if="scope.row.couponType==2">折扣券</div>
                <div v-if="scope.row.couponType==3">重测券</div>
              </template>
            </el-table-column>
            <el-table-column prop="remarks" label="启用" min-width="150">
              <template slot-scope="scope">
                <div v-if="scope.row.defaultUse==1">启用</div>
                <div v-if="scope.row.defaultUse==0">不启用</div>
              </template>
            </el-table-column>
            <el-table-column prop="remarks" label="用途" min-width="80">
              <template slot-scope="scope">
                <span v-if="scope.row.couponUse=='EXAM'">测评</span>
                <span v-if="scope.row.couponUse=='VIP'">会员</span>
                <span v-if="scope.row.couponUse=='GENERAL'">不限制</span>
              </template>
            </el-table-column>
            <el-table-column v-if="editShow || deleteShow" fixed="right" label="操作" min-width="180">
              <template slot-scope="scope">
                <el-button
                    @click="handleClick('change', scope.row)"
                    plain
                    v-if="editShow"
                    size="mini"
                >修改
                </el-button
                >
                <el-button
                    v-if="deleteShow"
                    type="primary"
                    plain
                    size="mini"
                    @click="del(scope.row)"
                >删除
                </el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <!-- 编辑弹框 -->
    <el-dialog
        title="编辑/新增券"
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        width="1000px"
        class="public-dialog"
    >
      <div class="public-dialog-form">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="100px"
        >
          <el-row>
            <el-col :span="8">
              <el-form-item label="券名称：" prop="name">
                <el-input
                    clearable
                    placeholder="请填写券名称"
                    v-model="params.name"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="副标题：" prop="shortName">
                <el-input
                    clearable
                    placeholder="请填写副标题"
                    v-model="params.shortName"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="券价格：" prop="price">
                <el-input
                    clearable
                    placeholder="请填写券价格"
                    v-model="params.price"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="券品类：" prop="couponCategory">
                <el-select clearable style="width: 100%" v-model="params.couponCategory" filterable
                           placeholder="请选择">
                  <el-option
                      label="答题支付送红包"
                      :value="1">
                  </el-option>
                  <el-option
                      label="答题支付送券"
                      :value="2">
                  </el-option>
                  <el-option
                      label="会员充值"
                      :value="3">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="券数量：" prop="couponCount">
                <el-input
                    clearable
                    placeholder="请填写券数量"
                    v-model="params.couponCount"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="券类型：" prop="couponType">
                <el-select clearable style="width: 100%" v-model="params.couponType" filterable placeholder="请选择">
                  <el-option
                      label="现金券"
                      :value="1">
                  </el-option>
                  <el-option
                      label="折扣券"
                      :value="2">
                  </el-option>
<!--                  <el-option-->
<!--                      label="重测券"-->
<!--                      :value="3">-->
<!--                  </el-option>-->
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="用途：" prop="couponUse">
                <el-select clearable style="width: 100%" v-model="params.couponUse" filterable placeholder="请选择">
                  <el-option
                      label="不限制"
                      value="GENERAL">
                  </el-option>
                  <el-option
                      label="测评"
                      value="EXAM">
                  </el-option>
                  <el-option
                      label="会员"
                      value="VIP">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="头部颜色：" prop="headColour">
                <el-input
                    clearable
                    placeholder="请填写头部颜色"
                    v-model="params.headColour"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="尾部颜色：" prop="footerColour">
                <el-input
                    clearable
                    placeholder="请填写尾部颜色"
                    v-model="params.footerColour"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="有效时间：" prop="effectiveTime">
                <el-input
                    clearable
                    placeholder="请填写有效时间"
                    v-model="params.effectiveTime"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="默认启用：" prop="defaultUse">
                <el-switch
                    v-model="params.defaultUse"
                    :active-value="1"
                    :inactive-value="0"
                >
                </el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="描述：" prop="remarks">
            <el-input
                clearable
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 4 }"
                placeholder="请填写描述"
                v-model="params.remarks"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
  </section>
</template>
<script>
import {PAGE_SIZE, COMMON_STATUS} from "@/config";

import {ossUpload} from "@utils/filters/upload";

export default {
  data() {
    return {
      PAGE_SIZE,
      COMMON_STATUS,
      loading: false,
      loading1: false, //加载中
      // 分页
      page: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      search: {},
      dialogVisible: false, //弹出框显示隐藏
      clickType: "", //弹窗类型
      params: {}, //弹窗修改数据
      rules: {
        name: [
          {required: true, message: "请填写券名称", trigger: "change"},
        ],
        shortName: [
          {required: true, message: "请填写副标题", trigger: "change"},
        ],
        price: [
          {required: true, message: "请填写券价格", trigger: "change"},
        ],
        couponCount: [
          {required: true, message: "请填写券数量", trigger: "change"},
        ],
        couponType: [
          {required: true, message: "请选择券类型", trigger: "change"},
        ],
        couponCategory: [
          {required: true, message: "请选择券品类", trigger: "change"},
        ],
        couponUse: [
          {required: true, message: "请选择券用途", trigger: "change"},
        ],
        effectiveTime: [
          {required: true, message: "请填写有效时间", trigger: "change"},
        ],
        headColour: [
          {required: true, message: "请填写头部颜色", trigger: "change"},
        ],
        footerColour: [
          {required: true, message: "请填写尾部颜色", trigger: "change"},
        ],
      }, //表单验证提示
      tableData: [], //二级--列表
      addShow: true,
      deleteShow: true,
      editShow: true,
      statusShow: false,
      searchShow: true,
      eventName:''
    };
  },
  created() {
    if (this.$route.query.id) {
      this.search.eventId = this.$route.query.id
      this.eventName = this.$route.query.name
    }
    this.getVipRightList();
    // this.getPermissionButtonList()
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
      }
    },
  },
  methods: {
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'system:enums:query') {
            this.searchShow = true
          }
          if (item.code == 'system:enums:add') {
            this.addShow = true
          }
          if (item.code == "system:enums:delete") {
            this.deleteShow = true
          }
          if (item.code == "system:enums:edit") {
            this.editShow = true
          }
          if (item.code == "system:enums:status") {
            this.statusShow = false
          }
        })
      }
    },
    SearchDictionaryList() {
      this.page.pageNo = 1
      this.getVipRightList()
    },
    /**
     *  get list 字典列表
     */
    async getVipRightList() {
      let http = "coupon/list";
      this.loading = true;
      const {data: resData} = await this.$post(http, {
        eventId:this.search.eventId,
      });
      this.loading = false;
      if (resData.data) {
        this.tableData = resData.data;
      } else {
        this.tableData = [];
      }
    },
    // 弹窗
    handleClick(type, row = {}) {
      this.clickType = type;
      this.dialogVisible = true;
      if (type == "change") {
        //修改  change
        this.params = JSON.parse(JSON.stringify(row));
      } else if (type == 'addNext') {
        //添加
        this.params = {
          defaultUse:0
        };
      }
    },
    //窗口--提交 修改信息
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认提交修改, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          this.params.eventName = this.eventName
          this.params.eventId = this.search.eventId
          const {data: resData} = await this.$post(
              "/coupon/save",
              this.params,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          this.$message.success("操作成功!");
          this.getVipRightList();
          this.dialogVisible = false
        });
      });
    },
    //删除
    del(row) {
      this.$confirm("一旦删除无法恢复, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$get(
            `/coupon/delete/${row.id}`,

            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.getVipRightList();
        this.$message.success("删除成功!");
      });
    },
    //分页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getVipRightList();
    },
    handleCurrentChange(val) {
      this.page.pageNo = val;
      this.getVipRightList();
    },
  },
};
</script>
<style lang="scss" scoped>
.role {
  display: flex;
  color: #666; /** 公共的黑色 --暂定 */
  font-size: 14px;

  &Right {
    flex: 1;
    display: flex;
    overflow-x: hidden;
    flex-direction: column;

    &_Top {
      display: flex;
      gap: 15px;
      overflow-x: hidden;

      .el-input {
        width: auto;
      }
    }

    &_Container {
      margin-top: 20px;

      .screenshot {
        position: relative;
      }
    }

    &_pagenation {
      margin: 40px auto;
    }
  }

  ::v-deep .el-table th,
  ::v-deep .el-table td {
    text-align: center !important;
  }
}
</style>
